<template>
  <div class="interactiveVideo">
    <iframe
      :src="
        `https://interactivevideo.swisstxt.ch/node/cling/api/video?assetId=${id}`
      "
      frameborder="0"
      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
      autoplay
    ></iframe>
  </div>
</template>

<script>
export default {
  name: "interactiveVideo",
  props: {
    id: {
      type: String
    }
  }
};
</script>
